/* Обёртка над fetch для системных маршрутов ядра (спека §2.2).
   При 401 сбрасывает authStore и уводит на /login (кроме публичных страниц — там сессии
   по определению нет, редирект туда же был бы циклом). */
import { t } from "../i18n/i18n";
import { isPublicPath } from "../auth/publicPaths";
// errorMessage — маппинг код→ключ словаря; бэк текст ошибки ещё присылает (до Ф3),
// но фронт его игнорирует и локализует сам по коду.
function errorMessage(code) {
    const key = `err.${code}`;
    const localized = t(key);
    return localized === key ? t("err.unknown") : localized;
}
export class ApiError extends Error {
    status;
    code;
    constructor(shape) {
        super(shape.message);
        this.status = shape.status;
        this.code = shape.code;
    }
}
// Коды 503 маркера состояния платформы (T-SET-5) — при них вместо обычной ошибки взводится
// platformStateStore, и App подменяет весь рендер на техстраницу; экспортируется — тот же
// набор кодов опознаёт техстраница (screens/Maintenance.tsx) при собственном опросе /api/status.
export const PLATFORM_RESTORE_CODES = new Set([
    "platform_restoring",
    "platform_restore_failed",
    "platform_updating",
    "platform_restore_rollback",
]);
export async function apiFetch(path, opts = {}) {
    const method = opts.method ?? "GET";
    const headers = { "Content-Type": "application/json" };
    const response = await fetch(path, {
        method,
        headers,
        body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
        credentials: "same-origin",
        signal: opts.signal,
    });
    if (response.status === 401) {
        const { useAuthStore } = await import("../state/authStore");
        useAuthStore.getState().clear();
        if (!isPublicPath(window.location.pathname)) {
            window.location.assign("/login");
        }
        throw new ApiError({ status: 401, code: "unauthenticated", message: errorMessage("unauthenticated") });
    }
    if (!response.ok) {
        let errBody = null;
        try {
            errBody = await response.json();
        }
        catch { /* тело могло не прийти */ }
        const code = errBody?.error?.code ?? `http_${response.status}`;
        if (response.status === 503 && PLATFORM_RESTORE_CODES.has(code) && errBody?.error) {
            const { usePlatformStateStore } = await import("../state/platformStateStore");
            const e = errBody.error;
            usePlatformStateStore.getState().set({
                state: e.state ?? "restoring",
                reason: e.reason ?? "",
                since: e.since ?? "",
            });
        }
        throw new ApiError({ status: response.status, code, message: errorMessage(code) });
    }
    if (response.status === 204 || response.headers.get("content-length") === "0") {
        return undefined;
    }
    return response.json();
}
